<template>
	<div>
		暂时没有主页
	</div>
</template>

<script setup lang="ts">
</script>